import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {ResponseList} from "../../../models/common/Response";
import {BucketImageDocType} from "../../../models/config/BucketImageDocType";

export const useBucketImageDocTypeMapping = () => {
    return useQuery({
        queryKey: ['bucket-image-doc-type-mapping'],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.get<ResponseList<BucketImageDocType>>(
                '/v1/configuration/lis/bucket-image-doc-type-mapping',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
        },
        select: response => response.data.result_list,
        retry: 1,
    });
}